var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7091 10.1188L8.76359 1.02761C7.969 -0.310073 6.03206 -0.31185 5.23641 1.02761L0.291126 10.1188C-0.521148 11.4856 0.46227 13.2166 2.05431 13.2166H11.9455C13.5362 13.2166 14.5214 11.487 13.7091 10.1188ZM7 11.5759C6.54779 11.5759 6.17968 11.2078 6.17968 10.7556C6.17968 10.3034 6.54779 9.9353 7 9.9353C7.45221 9.9353 7.82031 10.3034 7.82031 10.7556C7.82031 11.2078 7.45221 11.5759 7 11.5759ZM7 9.11499C7.45221 9.11499 7.82031 8.74689 7.82031 8.29468V4.19311C7.82031 3.7409 7.45221 3.3728 7 3.3728C6.54779 3.3728 6.17968 3.7409 6.17968 4.19311V8.29468C6.17968 8.74689 6.54779 9.11499 7 9.11499Z",
    fill: "#EEC201"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "2b1c34e091c7361151d601acaca34e9e.svg";
export { ForwardRef as ReactComponent };